// ./src/pushNotifications.js

import firebase from 'firebase/app';
import 'firebase/messaging';

export function initializeFirebase() {
  if (firebase.messaging.isSupported()) {
    const firebaseConfig = {
      apiKey: window.drupalSettings.firebase_api_key,
      authDomain: window.drupalSettings.firebase_project_id + ".firebaseapp.com",
      databaseURL: "https://" + window.drupalSettings.firebase_project_id + ".firebaseio.com",
      projectId: window.drupalSettings.firebase_project_id,
      storageBucket: window.drupalSettings.firebase_project_id + ".appspot.com",
      messagingSenderId: window.drupalSettings.firebase_sender_id,
      appId: window.drupalSettings.firebase_app_id,
      measurementId: window.drupalSettings.firebase_measurement_id
    };
    if (window.drupalSettings.push_notifications_enable) {
      firebase.initializeApp(firebaseConfig);

      const messaging = firebase.messaging();
      messaging.onMessage(function(payload) {
        var sender = JSON.parse(payload.data.message);
        console.log('Receiving foreground message', sender);
      });
      messaging
      .requestPermission()
      .then(() => {
        console.log("Permission granted");
        return messaging.getToken();
      })
      .then(token => {
        console.log(token)
      })
      .catch(error => {
          console.log('Error Occurred', error);
      });
    }
  }
}
